<template>
  <section>
    <div class="container-fluid">
      <div class="row" style="margin-bottom: 2em">
        <div class="col-xs-12">
          <h4>Send Sample Email Template</h4>
          <form>
            <p>Send a sample of one of your emails to the provided email address. This is useful for testing your
              templates.</p>
            <div class="form-group">
              <label for="template_name">Email template</label>
              <select class="form-control" name="template_name" v-model="sampleEmail.template">
                <option v-bind:value="template.name" v-for="template in emailTemplates">
                  {{ template.display_name }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="recipient">Email Address</label>
              <input name="recipient" type="email" v-model="sampleEmail.recipient" class="form-control text-left" />
            </div>
            <div class="form-group">
              <button class="btn btn-dc" @click.prevent="sendSampleEmail()">Send Sample Email</button>
            </div>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h4>Email Templates</h4>
          <div class="template-grid">
            <div class="template-card" v-bind:key="template.id" v-for="template in emailTemplates">
              <div class="template-card__heading">
                <h5 class="template-card__title">{{ template.display_name }}</h5>
              </div>
              <div class="template-card__body">
                <dl class="template-card__meta">
                  <dt>Sent</dt>
                  <dd>{{ template.sent_when }}</dd>

                  <dt>Customized</dt>
                  <dd>
                    <span class="status-badge" :class="template.customized ? 'status-badge--yes' : 'status-badge--no'">
                      {{ template.customized ? 'Yes' : 'No' }}
                    </span>
                  </dd>

                  <dt>Send email</dt>
                  <dd>
                    <span class="status-badge"
                      :class="template.send_this_email ? 'status-badge--yes' : 'status-badge--no'">
                      {{ template.send_this_email ? 'Yes' : 'No' }}
                    </span>
                  </dd>

                  <dt>Modified</dt>
                  <dd>{{ template.customized ? template.updated_at : 'N/A' }}</dd>
                </dl>
              </div>
              <div class="template-card__footer">
                <button class="btn btn-dc" @click.prevent="selectTemplate(template)">Preview/Edit</button>
                <!-- <button class="btn btn-dc mt-2" @click.prevent="toggleSendTemplate(template)">{{ template.send_this_email ? 'Turn Off' : 'Turn On' }}</button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import EmailEditor from '../email-editor/EmailEditor.vue'

export default {
  name: 'dc-email-templates',
  components: {
    'dc-email-editor': EmailEditor
  },
  props: {
  },
  data() {
    return {
      sampleEmail: {
        recipient: '',
        template: ''
      }
    }
  },
  created() {
    this.$store.dispatch('GET_EMAIL_TEMPLATES')
  },
  methods: {
    selectTemplate(template) {
      this.$emit('select-template', template);
    },
    sendSampleEmail() {
      this.$store.dispatch('SEND_SAMPLE_EMAIL', { recipient: this.sampleEmail.recipient, name: this.sampleEmail.template }).then(response => {
        let data = { 'message': response.data.message };
        this.$emit('email-sample-sent', { 'data': data })
      })
    },
    toggleSendTemplate(template) {
      const emailTemplate = Object.assign({}, template);
      emailTemplate.key = template.name;
      if (emailTemplate.send_this_email === true) {
        emailTemplate.send_this_email = "0";
      } else {
        emailTemplate.send_this_email = "1";
      }
      this.$store.dispatch('PUBLISH_EMAIL_TEMPLATE', emailTemplate).then(response => {
        let data = { 'message': response.data.message, 'template': response.data.template };
        this.$emit('email-template-published', { 'data': data })
      })
    }
  },
  computed: {
    emailTemplates: function () {
      return this.$store.state.emailEditor.templates;
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../../assets/css/partials/variables.scss';

.template-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 15px;
}

.template-card {
  display: flex;
  flex-direction: column;
  background: $white;
  border: 1px solid darken($light, 3%);
  border-radius: 3px;
  overflow: hidden;
  transition: box-shadow 0.15s ease, transform 0.15s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba($black, 0.12);
    transform: translateY(-2px);
  }

  &__heading {
    padding: 12px 15px;
    background: $white;
    border-bottom: 2px solid $green;
  }

  &__title {
    margin: 0;
    font-weight: 700;
    color: $black;
  }

  &__body {
    flex: 1 1 auto;
    padding: 15px;
  }

  &__meta {
    margin: 0;

    dt {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: $light-grey;
      margin-top: 10px;

      &:first-child {
        margin-top: 0;
      }
    }

    dd {
      margin: 2px 0 0;
      color: $black;
    }
  }

  &__footer {
    padding: 12px 15px;
    background: $white;
    border-top: 1px solid darken($light, 3%);

    .btn-dc {
      display: block;
      width: 100%;
    }
  }
}

.status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: $white;

  &--yes {
    background-color: $green;
  }

  &--no {
    background-color: $light-grey;
  }
}
</style>
